import api from "./axios";
import type { Category } from "@/types";

export const getAll = () =>
  api.get<Category[]>("/categories").then((r) => r.data);

export const getById = (id: string) =>
  api.get<Category>(`/categories/${id}`).then((r) => r.data);

export const create = (data: { name: string }) =>
  api.post<Category>("/categories", data).then((r) => r.data);

export const update = (id: string, data: { name?: string }) =>
  api.patch<Category>(`/categories/${id}`, data).then((r) => r.data);

export const remove = (id: string) =>
  api.delete(`/categories/${id}`).then((r) => r.data);
